import resilenderLogo from "../../../../../assets/resilender-logo.png"; // Adjust the path as necessary
import resfinLogo from "../../../../../assets/resfin-logo.png"; // Adjust the path as necessary
import lendmarqLogo from "../../../../../assets/logos/lendmarq-logo.png"; // Adjust the path as necessary
import eastviewLogo from "../../../../../assets/logos/eastview-logo.png";
import PdfImage from "../../components/images/PdfImage";
import { useEnv } from "../../../../../hooks/useEnv";

/**
 * The partner logo on every generated PDF.
 *
 * ORDER MATTERS. `useEnv().isResfin` is true for `resfin` **and** `eastview`
 * **and** `lendmarq` (it is a "shares the resfin backend" flag, not a brand
 * flag), so the specific brands have to be tested BEFORE it or they fall through
 * and print the resfin mark. Eastview was doing exactly that.
 */
const PdfBuilderLogo = ({ width, height, size = 32, style = {} }) => {
  const { isEastview, isResfin, isLendmarq } = useEnv();

  if (isEastview) {
    // eastview-logo.png is 180×50 — hold the native 3.6:1 ratio so the wordmark
    // doesn't stretch.
    const logoWidth = 92;
    const logoHeight = logoWidth / 3.6;
    return (
      <PdfImage
        src={eastviewLogo}
        width={width || logoWidth}
        height={height || logoHeight}
        style={style}
      />
    );
  }
  if (isLendmarq) {
    const logoWidth = 105;
    const logoHeight = logoWidth / 5.37037037037;
    return (
      <PdfImage
        src={lendmarqLogo}
        width={width || logoWidth}
        height={height || logoHeight}
        style={style}
      />
    );
  }
  if (isResfin) {
    return (
      <PdfImage
        src={resfinLogo}
        width={width || size}
        height={height || size / 1.225}
        style={style}
      />
    );
  }
  return (
    <PdfImage src={resilenderLogo} width={size} height={size} style={style} />
  );
};

export default PdfBuilderLogo;
